import script from "./Payroll-Run-Details.vue?vue&type=script&setup=true&lang=js"
export * from "./Payroll-Run-Details.vue?vue&type=script&setup=true&lang=js"

import "./Payroll-Run-Details.vue?vue&type=style&index=0&id=28b5d85a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b5d85a"]])

export default __exports__